<template>
	<div>
		<compFormEdit ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData" col="1"></compFormEdit>
		<vButtonGroup class="text-right margin-top-10">
			<vButton theme="primary" @click="submit">{{$t('global.common.save', { defaultValue: '保存' })}}</vButton>
			<vButton @click="cancel">{{$t('global.common.return', { defaultValue: '返回' })}}</vButton>
		</vButtonGroup>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import { HttpMaterial, HttpSaveMaterial } from '@/service/billing';
import { mapGetters } from "vuex";
export default {
	props: ['params'],
	data() {
		return {
			loading: false,
			formData: {
				currency: 'USD'
			}
		}
	},
	components: {
		compFormEdit: () => import("@components/templates/formedit"),
	},
	created() {
		this.getDetail();
	},
	computed: {
		...mapGetters('dictionary', ['getBillcusWareList']),
		getBase() {
			const isEdit = this.params.type === 'edit';
			return [
				{
					label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
					tag: "vSelect",
					key: "warehouseId",
					query: isEdit,
					props: {
						filterable: true,
					},
					on:{
						'on-attach':(attach)=>{
							this.formData.warehouseCode=attach.code;
						}
					},
					options: this.getBillcusWareList
				},
				{
					label: this.$t('fbb.accountmanage.material_code', { defaultValue: "包材Code" }),
					key: "materialCode",
					query: isEdit,
				}, {
					label: this.$t('fbb.accountmanage.material_name', { defaultValue: "包材名称" }),
					key: "name",
				}, {
					label: this.$t('fbb.accountmanage.material_size', { defaultValue: '包材尺寸' }) + "(cm)",
					tag: "vInputNumber",
					key: "length",
					span: 12,
					props: {
						placeholder: this.$t('fbb.accountmanage.material_size_length', { defaultValue: '长' })
					}

				}, {
					label: "",
					labelWidth: 16,
					tag: "vInputNumber",
					key: "width",
					span: 6,
					props: {
						placeholder: this.$t('fbb.accountmanage.material_size_width', { defaultValue: '宽' })
					}
				}, {
					label: "",
					labelWidth: 16,
					tag: "vInputNumber",
					key: "height",
					span: 6,
					props: {
						placeholder: this.$t('fbb.accountmanage.material_size_height', { defaultValue: '高' })
					}
				}, {
					label: this.$t('global.common.weight', { defaultValue: '重量' }) + "(g)",
					tag: "vInputNumber",
					key: "weight",
				}, {
					label: this.$t('fbb.accountmanage.cost', { defaultValue: "成本" }),
					tag: "vInputNumber",
					key: "cost",
				}, {
					label: this.$t('global.common.currency', { defaultValue: "币种" }),
					key: "currency",
					query: true,
				}, {
					label: this.$t('global.common.notes', { defaultValue: "备注" }),
					tag: "vTextarea",
					key: "remark",
					required: false,
				}
			];
		},
	},
	methods: {
		cancel() {
			this.$emit('on-close')
		},
		getDetail() {
			if (this.params.type === 'add') return;
			this.loading = true;
			HttpMaterial({ id: this.params.id }).then(res => {
				this.loading = false;
				this.formData = res.data;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message)
			})
		},
		async submit() {
			const valid=await this.$refs.formbase.validate();
			if(!valid) return;
			this.loading = true;
			HttpSaveMaterial(this.formData).then(res => {
				this.loading = false;
				this.cancel();
				this.$emit('on-update');
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message)
			})
		},
	},
}
</script>